import { StyleSheet, Text, View, Platform } from 'react-native';
import React from 'react';
import FontAwesome6 from '@react-native-vector-icons/fontawesome6/static';
import { useAppSelector } from '../../redux/helper';
import { selectCartTotalQuantity } from '../../redux/cartSlice';
import { isTablet } from 'react-native-device-info';
import { borderWidth, fs, iconSize, s, v } from '../../utils/libs';

/** The Basket's icon (FontAwesome6, solid), wherever the basket is shown. */
export const BASKET_ICON_NAME = 'basket-shopping' as const;

interface CartIconProps {
  iconColor?: string;
  badgeBackgroundColor?: string;
  badgeTextColor?: string;
  badgeBorderColor?: string;
  size?: number;
  countOverride?: number;
}

const CartIcon = React.memo(
  ({
    iconColor = '#fff',
    badgeBackgroundColor = '#fff',
    badgeTextColor = '#1560bd',
    badgeBorderColor = '#1560bd',
    size = iconSize(20),
    countOverride,
  }: CartIconProps) => {
    const cartTotalQuantityFromStore = useAppSelector(selectCartTotalQuantity);
    const cartTotalQuantity =
      typeof countOverride === 'number'
        ? Math.max(0, countOverride)
        : cartTotalQuantityFromStore;
    const badgeSize = Math.max(size * 0.8, v(18));
    const fontSize = Math.max(size * 0.45, fs(10));
    const topOffset = size * 0.4;
    const rightOffset = size * 0.08;

    return (
      <View style={styles.pressable}>
        <FontAwesome6
          name={BASKET_ICON_NAME}
          iconStyle="solid"
          size={size}
          color={iconColor}
        />
        {cartTotalQuantity > 0 && (
          <View
            style={[
              styles.circle,
              {
                backgroundColor: badgeBackgroundColor,
                borderColor: badgeBorderColor,
                width: badgeSize,
                height: badgeSize,
                borderRadius: badgeSize / 2,
                top: topOffset,
                right: rightOffset,
              },
            ]}>
            <Text style={[styles.count, { color: badgeTextColor, fontSize }]}>
              {cartTotalQuantity}
            </Text>
          </View>
        )}
      </View>
    );
  },
);

export default CartIcon;

const styles = StyleSheet.create({
  pressable: {
    position: 'relative',
    height: v(isTablet() ? 42 : 42),
    width: s(isTablet() ? 32 : 42),
    justifyContent: 'center',
    alignItems: 'center',
  },
  cart: {
    // Color now set via props
  },
  circle: {
    position: 'absolute',
    right: Platform.OS === 'web' ? 1 : borderWidth(1),
    borderWidth: borderWidth(1),
    justifyContent: 'center',
    alignItems: 'center',
  },
  count: {
    fontWeight: 'bold',
    textAlign: 'center',
  },
});
